import axios from "axios";
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { fetchError } from "./commonSlice";

const initialState = {
  list: [],
  perPage: "",
  total: 0,
  loading: false,
};

export const getPartyNumberList = createAsyncThunk(
  "get-party-number",
  async (data, { dispatch }) => {
    try {
      const response = await axios.get("party-number/list", { params: data });
      return response;
    } catch (error) {
      dispatch(fetchError(error));
      return error;
    }
  },
);

// Same endpoint as the list, for the Excel download: every row the current
// filters match, in one page.
//
// Deliberately has no reducer case - these rows go straight into the file, and
// putting them in `state.list` would replace the page on screen with the whole
// filtered set.
export const exportPartyNumberList = createAsyncThunk(
  "export-party-number",
  async (data, { dispatch }) => {
    try {
      const response = await axios.get("party-number/list", { params: data });
      return response;
    } catch (error) {
      dispatch(fetchError(error));
      return error;
    }
  },
);

export const createPartyNumber = createAsyncThunk(
  "create-party-number",
  async (data, { dispatch }) => {
    try {
      const response = await axios.post("party-number", data);
      return response;
    } catch (error) {
      dispatch(fetchError(error));
      return error;
    }
  },
);

export const updatePartyNumber = createAsyncThunk(
  "update-party-number",
  async ({ id, data }, { dispatch }) => {
    try {
      const response = await axios.put(`/party-number/${id}`, data);
      return response;
    } catch (error) {
      dispatch(fetchError(error));
      return error;
    }
  },
);

export const deletePartyNumber = createAsyncThunk(
  "delete-party-number",
  async (id, { dispatch }) => {
    try {
      const response = await axios.delete(`/party-number/${id}`);
      return response;
    } catch (error) {
      dispatch(fetchError(error));
      return error;
    }
  },
);

const partyNumberSlice = createSlice({
  name: "partyNumber",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getPartyNumberList.pending, (state) => {
        state.loading = true;
      })
      .addCase(getPartyNumberList.fulfilled, (state, action) => {
        state.loading = false;
        state.list = action?.payload?.data?.data?.partyNumberList ?? [];
        state.perPage = action?.payload?.data?.data?.perPage ?? 1;
        state.total = action?.payload?.data?.data?.total ?? 0;
      })
      .addCase(getPartyNumberList.rejected, (state) => {
        state.loading = false;
        state.list = [];
        state.perPage = "";
        state.total = 0;
      });
  },
});

export default partyNumberSlice.reducer;
